<template lang="html">

  <section class="game-list">
    <AdminHeader></AdminHeader>
    <h1 class="mb-5">Spiele Übersetzungen</h1>
    <v-row v-bind:key="game.id" v-for="game in games" class="game_list_item">
      <v-col cols="12">
        <v-row>
          <v-col cols="6">
            <v-text-field outlined v-model="game.name.de" label="Name DE"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field outlined v-model="game.name.en" label="Name EN"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-textarea outlined v-model="game.description.de"
                        label="Beschreibung DE"></v-textarea>
          </v-col>
          <v-col cols="6">
            <v-textarea outlined v-model="game.description.en"
                        label="Beschreibung EN"></v-textarea>
          </v-col>
        </v-row>
        <hr>
      </v-col>
    </v-row>
    <v-btn @click="updateGames" class="button">Speichern</v-btn>
  </section>

</template>

<script lang="js">
import AdminHeader from "./AdminHeader";
import GameService from "../../services/GameService";

export default {
  name:       'game-list',
  components: {AdminHeader},
  props:      [],
  mounted () {
    this.getGames();
  },
  data () {
    return {
      'games': [],
    }
  },
  methods:  {
    getGames () {
      GameService.getLimitGames(20).then(res => {
        console.log(res);
        this.games = res.data;
      })
                 .catch(err => console.log(err));
    },
    updateGames () {
      console.log(this.games);
      GameService.updateGames(this.games).then(res => {
        console.log(res);
        this.getGames();
      }).catch(err => console.log(err));
    }
  },
  computed: {}
}


</script>

<style scoped lang="scss">
.game-list {

}

.add_game, .add_game i {
  color: var(--v-primary-base) !important;
}

a {
  text-decoration: none !important;
}

</style>
